import { Link } from 'react-router-dom';
import { Headphones, Play, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const PodcastSection = () => {
  return (
    <section data-testid="podcast-section" className="bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10 items-center">
          {/* Left - Visual */}
          <div className="md:col-span-4 flex justify-center md:justify-start">
            <div className="w-56 h-56 sm:w-64 sm:h-64 bg-[#002868] border border-slate-200 relative overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center opacity-30"
                style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1660832458429-526d0601054f?w=400&h=400&fit=crop)' }}
              />
              <div className="relative h-full flex flex-col items-center justify-center p-6">
                <Headphones className="w-12 h-12 text-[#FFB612] mb-4" />
                <h3 className="font-heading text-xl text-white text-center uppercase tracking-wide">
                  DC Sports Report
                </h3>
                <p className="text-white/70 text-xs font-bold uppercase tracking-[0.25em] mt-2">
                  Podcast
                </p>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="md:col-span-8">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#BF0A30]">
              <Play className="w-3.5 h-3.5" fill="currentColor" />
              New Episodes Weekly
            </span>

            <h2 className="font-serif-head font-extrabold text-3xl sm:text-4xl text-slate-900 tracking-tight leading-tight mt-3">
              The DC Sports Report Podcast
            </h2>

            <p className="text-slate-600 text-base leading-relaxed mt-4 max-w-xl">
              In-depth analysis, exclusive interviews, and the latest takes on the
              Commanders, Capitals, Nationals, and Wizards. Your weekly dose of DC sports.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mt-7">
              <Link to="/podcast">
                <Button
                  data-testid="podcast-listen-now-button"
                  className="h-12 px-7 rounded-none bg-[#002868] hover:bg-[#001d4d] text-white font-heading font-medium uppercase tracking-wide"
                >
                  <Headphones className="w-4 h-4 mr-2" />
                  Listen Now
                </Button>
              </Link>

              <Link to="/podcast">
                <Button
                  variant="outline"
                  data-testid="podcast-all-episodes-button"
                  className="h-12 px-7 rounded-none bg-transparent hover:bg-slate-100 text-slate-900 font-heading font-medium uppercase tracking-wide border border-slate-300"
                >
                  All Episodes
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PodcastSection;
